import React, { useRef, useEffect, Fragment } from "react";
import { useContext } from "react";
import { useNavigate, useLocation, useParams, Link, Navigate } from "react-router-dom";
import parse, { attributesToProps, domToReact } from "html-react-parser";

import { AppContext } from "@component/AppProvider";
import _CK from "@util/cookie";
import _CFG from "@config/defaults";

const Header = (props) => {
    const { site, saveIam } = useContext(AppContext);
    const navigate = useNavigate();

    const onLogout = (e) => {
        e.preventDefault();

        saveIam(null);
        _CK.clearAuth();
        navigate("/");
    };

    if (site.header) {
        return parse(site.header, {
            replace(domNode) {
                if (domNode?.attribs) {
                    const props = attributesToProps(domNode.attribs);

                    if (_CK.isLogin()) {
                        if (domNode?.attribs?.class?.includes("no-login")) {
                            props.className = props.className + " hide";
                            return <a {...props}>{domToReact(domNode?.children)}</a>;
                        }
                        if (domNode?.attribs?.class?.includes("is-login")) {
                            props.className = props.className?.replace("hide", "");

                            if (props.className?.includes("btn-logout")) {
                                return (
                                    <a {...props} onClick={onLogout}>
                                        {domToReact(domNode?.children)}
                                    </a>
                                );
                            }

                            return <a {...props}>{domToReact(domNode?.children)}</a>;
                        }
                    } else {
                        if (domNode?.attribs?.class?.includes("no-login")) {
                            props.className = props.className?.replace("hide", "");
                            return <a {...props}>{domToReact(domNode?.children)}</a>;
                        }
                        if (domNode?.attribs?.class?.includes("is-login")) {
                            props.className = props.className + " hide";
                            return <a {...props}>{domToReact(domNode?.children)}</a>;
                        }
                    }
                }
            },
        });
    }

    return <Fragment />;
};

export default Header;
